import * as React from "react";
import KnowladgeWaysOfCommunication from "../containers/KnowladgeWaysOfCommunication";

export default (props) => <KnowladgeWaysOfCommunication {...props} />;
